<template>
    <div class="card-group">
        <app-actuators
            v-for="actuator in actuators"
            :actuator="actuator"
            @setActuator="setActuator"
            :key="actuator.name"
        ></app-actuators>
    </div>
</template>

<script>
import Actuators from "./Actuator.vue";
import axios from "axios";

export default {
    data() {
        return {
            actuators: [],
            numberOfContacts: 0,
        };
    },

    components: {
        appActuators: Actuators,
    },

    computed: {},

    mounted() {
        this.getActuators();
    },

    methods: {
        getActuators() {
            const app = this;
            return axios
                .get("/master/actuator_list")
                .then((res) => {
                    app.actuators = res.data;

                    //app.sensors = Object.entries(res.data)
                    console.log(res.data);
                    console.log("Actuators :" + app.actuators);
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        setActuator(e) {
            var url = "/" + e.name;
            var data = {
                action: e.state == "on" ? "switch_on" : "switch_off",
            };
            
            return axios
                .post(url, data, {
                    headers: {
                        Accept: "application/json",
                        "Content-type": "application/json",
                        Authorization:
                            "Bearer W0OEQlXdO8KqXb-WjmJaBA9tZGxCLGQt3oc58qGUKXKysvDP7BSQRLC_ixJXWQgz4jkZptJJuqV8Zam0Hk_sDA6mF2Wh9E9VYjc30NJuMRxdxKCK5k6nMxZqDTNXpMowd8-CIltsdWoP0bdtelY5s505CCEGhud2wBdh4ovRNyigBZsK4vJ-uAPSorVc-cR8XxzXTIbwUgfRCqiHxmpqi_v4SNjVQIxCqHvGVec2x_bJKecu1jS4pSQA4jxB9KsEbbVCw3-ExjS3BC69yuSIaH8SzBzOTpHR2igHbGP2X6zk2s-jVkBRIigENqXiW_eqNBecewpj9-H5zW3pDG4kfw",
                    },
                })
                .then((response) => {
                    alert(JSON.stringify(response));
                    //this.getActuators();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>